import React, {useEffect, useState} from 'react';
import {NotificationManager} from 'react-notifications';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {LinkOutlined as LinkOutlinedIcon} from '@material-ui/icons';

const avcoreUrl = process.env.REACT_APP_AVCORE_URL || 'https://streaming.myonvent.com';

const LinksModule = ({routeParams}) => {
    let {sessionId, registerParam} = routeParams;
    const [loc, setLoc] = useState();
    const [links, setLinks] = useState([]);

    useEffect(() => {
        if (registerParam) return;
        let location = window.location.href;
        if (location.slice(-1) === '/') {
            setLoc(location);
        } else setLoc(location + '/');
        const regLinks = [
            {
                title: 'Streaming URL',
                url: `${avcoreUrl.replace('https', 'rtmp')}/live`,
                _id: 'rtmp-url',
            },
            {
                title: 'Streaming Key',
                url: `${sessionId}Z`,
                _id: 'session-id',
            },
            {
                title: 'Live streaming page URL',
                url: window.location.href,
                _id: 'page-link',
            },
        ];
        setLinks(regLinks);
    }, [loc, registerParam, sessionId]);

    return (
        <>
            {!!links.length && (
                <div className="module">
                    <div className="module-container">
                        <div className="module-header">
                            <span>SESSION LINKS</span>
                        </div>
                        <div className="module-body">
                            <div className="module-link_blocks">
                                {links.map((link) => {
                                    return (
                                        <CopyToClipboard
                                            key={link._id}
                                            text={link.url}
                                            onCopy={() => NotificationManager.info('Copied to clipboard')}
                                        >
                                            <div className="module-link_block">
                                                <span>{link.title}</span>
                                                <button type="button" className="button">
                                                    <LinkOutlinedIcon className="button_icon" />
                                                    <span>copy</span>
                                                </button>
                                            </div>
                                        </CopyToClipboard>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LinksModule;
